<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else contactUsFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="contactUsFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #contactUsFlexColumnTemplate>
  <div fxFlex.lt-md="60px" fxFlex.gt-sm="25px">&nbsp;</div>         <!-- 11/01/2021 RA - Increased from 10px to 60px to move info box down -->
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else contactUsMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="contactUsMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #contactUsMainFlexColumnTemplate>
 <!--  <div fxFlex="50%" fxHide.lt-md></div>
  <div fxFlex="500px" fxLayoutAlign="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="showSpinner">   -->
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxLayoutAlign="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="showSpinner">
    <div class="display-text normal-paragraph-spacing" style="text-align: center">
      <mat-spinner color="accent" diameter="64"></mat-spinner>
    </div>
  </div>
  <div fxFlex="90%"  fxLayoutAlign="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column" *ngIf="this.companyInformationFound && this.contactEmailInformationFound">
            <div *ngIf="isBrowserIE; else contactUsFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="contactUsFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #contactUsFormFlexColumnTemplate>
  <div fxLayout="column">
    <form [formGroup]="contactUsForm">
      <div class="display-text primary-dark-color-important">
        <b><span i18n="@@contact-us.title">contact-us.title</span></b>
      </div>
      <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
      <div class="display-text normal-paragraph-spacing">
        <b
          ><span i18n="@@contact-us.top.statement.1">contact-us.top.statement.1</span>&nbsp;{{
            formatPhoneNumber(companyInformation.customerServiceNumber)
          }}<span i18n="@@contact-us.top.statement.2">contact-us.top.statement.2</span></b
        >
      </div>
      <div class="display-text normal-paragraph-spacing">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@contact-us.form.email-address.label"
            placeholder="contact-us.form.email-address.label"
            type="email"
            [formControl]="emailAddressFormControl"
            autocomplete="email"
            [maxlength]="fieldValidations.contact.emailAddressMaxLength"
            required
          />
          <mat-error class="form-error" *ngIf="emailAddressFormControl.hasError('required')" i18n="@@contact-us.form.error.required"
            >contact-us.form.error.required</mat-error
          >
          <mat-error
            *ngIf="emailAddressFormControl.hasError('pattern') && !emailAddressFormControl.hasError('required')"
            i18n="@@contact-us.form.error.email"
            >contact-us.form.error.email</mat-error
          >
        </mat-form-field>
      </div>
      <div class="display-text normal-paragraph-spacing">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <textarea
            matInput
            i18n-placeholder="@@contact-us.form.email-message.label"
            placeholder="contact-us.form.email-message.label"
            [formControl]="emailMessageFormControl"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="25"
            required
          ></textarea>
          <mat-error class="form-error" *ngIf="emailMessageFormControl.hasError('required')" i18n="@@contact-us.form.error.required"
            >contact-us.form.error.required</mat-error
          >
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing">
        <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}" required></re-captcha>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing" *ngIf="!userVerified">
        <button
          mat-flat-button
          color="primary"
          (click)="submitMessage()"
          [disabled]="!contactUsForm.valid || showSuccess"
          i18n="@@contact-us.form.submit-button.label"
          *ngIf="!showSubmitMessageSpinner"
        >
          contact-us.form.submit-button.label
        </button>
        <mat-spinner color="accent" diameter="32" *ngIf="showSubmitMessageSpinner"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text highlighted-display-text normal-paragraph-spacing"
        *ngIf="showSuccess"
      >
        <b><span i18n="@@contact-us.submit-message.success.1">contact-us.submit-message.success.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text highlighted-display-text normal-paragraph-spacing"
        *ngIf="showSuccess"
      >
        <b><span i18n="@@contact-us.submit-message.success.2">contact-us.submit-message.success.2</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showError"
      >
        <b><span i18n="@@contact-us.submit-message.error.1">contact-us.submit-message.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showError"
      >
        <b><span i18n="@@contact-us.submit-message.error.2">contact-us.submit-message.error.2</span></b>
      </div>
      <div class="display-text large-paragraph-pre-spacing">
        <b><span i18n="@@contact-us.company-address.header">contact-us.company-address.header</span></b>
      </div>
      <div class="display-text">{{ companyInformation.companyName }}</div>
      <div class="display-text">{{ companyInformation.addressLine1 }}</div>
      <div class="display-text">{{ companyInformation.addressLine2 }}</div>
      <div class="display-text">
        {{ companyInformation.city }},&nbsp;{{ companyInformation.state }}&nbsp;&nbsp;{{ companyInformation.zipCode }}
      </div>
      <div class="display-text normal-paragraph-pre-spacing">
        {{ companyInformation.companyName }}&nbsp;<span i18n="@@contact-us.bottom.statement.1">contact-us.bottom.statement.1</span>&nbsp;{{
          companyInformation.hoursOpen
        }},&nbsp;{{ companyInformation.dayOfWeekOpen }}.
      </div>
    </form>
  </div>
</ng-template>
